export default __webpack_public_path__ + "static/media/image2.22318742.avif";